import { subagentChatMessage } from '@/app/api/subagents/[id]/route.def';
import { defineRouteDef, z } from '@/domains/common/api';

export const subagentStreamEvent = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('message'), message: subagentChatMessage }),
  z.object({
    kind: z.literal('status'),
    status: z.string(),
    failure_reason: z.string().nullable(),
  }),
  z.object({
    kind: z.literal('tool_use'),
    tool_name: z.string(),
    args: z.unknown(),
  }),
  z.object({
    kind: z.literal('tool_result'),
    tool_name: z.string(),
    ok: z.boolean(),
    summary: z.string().nullable(),
  }),
  z.object({
    kind: z.literal('end'),
    reason: z.enum(['terminal', 'no_live_runtime']),
  }),
  z.object({ kind: z.literal('error'), message: z.string() }),
]);
export type SubagentStreamEvent = z.infer<typeof subagentStreamEvent>;

export const subagentStreamRoute = defineRouteDef({
  method: 'GET',
  path: '/api/subagents/[id]/stream',
  audience: 'user',
  params: z.object({ id: z.uuid() }),
  query: z.object({ since_seq: z.coerce.number().nonnegative().optional() }),
  events: subagentStreamEvent,
});
